module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "OT"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "CON1"
  }, [_c('a', {
    attrs: {
      "href": "#/CoverImage"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1"
  }, [_c('a', {
    attrs: {
      "href": "#/Dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text2#toc_marker-3"
    }
  }, [_vm._v("1. Setting the Stage")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text2#toc_marker-3-1"
    }
  }, [_vm._v("A Change in Hearing")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text2#toc_marker-3-2"
    }
  }, [_vm._v("Proposal and Plan of the Book")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text2#toc_marker-3-3"
    }
  }, [_vm._v("Introducing Distance in Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text3#toc_marker-4"
    }
  }, [_vm._v("2. Aesthetic Distance in Performance")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text3#toc_marker-4-1"
    }
  }, [_vm._v("Aesthetic Distance")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text3#toc_marker-4-2"
    }
  }, [_vm._v("Performing Distance")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text3#toc_marker-4-3"
    }
  }, [_vm._v("Backdrop for Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text4#toc_marker-5"
    }
  }, [_vm._v("3. Distance in Preaching:Fred Craddock’s Homiletical Method")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text4#toc_marker-5-1"
    }
  }, [_vm._v("Preserving the Text: Distance in Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text4#toc_marker-5-2"
    }
  }, [_vm._v("Protecting the Hearer: Distance in the Sermon")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text4#toc_marker-5-3"
    }
  }, [_vm._v("Respecting the Hearer: Distance in Delivery")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text4#toc_marker-5-4"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text5#toc_marker-6"
    }
  }, [_vm._v("4. Absorption in the Sermon:Postliberal Homiletics")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text5#toc_marker-6-1"
    }
  }, [_vm._v("Mark Ellingsen’s Homiletic")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text5#toc_marker-6-2"
    }
  }, [_vm._v("Charles Campbell’s Homiletic")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text5#toc_marker-6-3"
    }
  }, [_vm._v("Absorption Reconsidered")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text6#toc_marker-7"
    }
  }, [_vm._v("5. Clearing the Sanctuary: Room and Space")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text6#toc_marker-7-1"
    }
  }, [_vm._v("Distance Reconsidered")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text6#toc_marker-7-2"
    }
  }, [_vm._v("Recent Proposals")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text6#toc_marker-7-3"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text62#toc_marker-8"
    }
  }, [_vm._v("Two Sermons")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text62#toc_marker-8-1"
    }
  }, [_vm._v("“Were You There?”")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text62#toc_marker-8-2"
    }
  }, [_vm._v("“Sibling Revelry”")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text7#toc_marker-9"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text8#toc_marker-10"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-431f778b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Brothers_Distance_in_Preaching_text-1.vue
// module id = 66
// module chunks = 0